import * as React from 'react';
import { Tabs, Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';
const TabPane = Tabs.TabPane;

import { DocumentGenerationController } from 'src/app/general/document-generation/document-generation.controller';
import { HeaderView } from 'src/app/shared/header.view';
import { ContextService } from 'src/core/services/context.service';
import { AgentGeneralPartController } from './parts/agent-general.controller';
import { AgentContactPartController } from './parts/agent-contact.controller';
import { AgentBrandController } from '../../agent-brands/agent-brand.controller';
import { AgentBrandDataService } from 'src/app/bookings/agent-brands/agent-brand-form.data';
import { AgentPolicyDataService } from 'src/app/bookings/agent-policies/agent-policy-form.data';
import { AgentPolicyController } from 'src/app/bookings/agent-policies/agent-policy.controller';
import { ChildrenAgents } from 'src/app/bookings/agents/form/parts/children-agents';
import { AgentMarketDataService } from 'src/app/bookings/agent-markets/agent-market-form.data';
import { AgentMarketController } from 'src/app/bookings/agent-markets/agent-market.controller';

interface Props extends ComponentViewProps<AgentItem> {
	brandDataService: AgentBrandDataService;
	policyDataService: AgentPolicyDataService;
	title: string;
	isNew: boolean;
	save: () => Promise<void>;
	cancel: () => void;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	currency: CurrencySummary;
	onChangeCurrency: (currency: CurrencySummary) => void;
	contextService: ContextService;
	match: any;
	location: any;
	history: any;
	offset?: boolean;
	showHeader?: boolean;
	className?: boolean;
	marketDataService: AgentMarketDataService;
}

@observer
export class AgentFormView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const {
			model, brandDataService, policyDataService, marketDataService,
			title, isNew, save, cancel,
			mode, onModeChange, currency, onChangeCurrency,
			contextService, setBusy, match, location, history
		} = this.props;
		if (model == null) {
			return null;
		}

		return (
			<div className={(this.props.className == null || this.props.className == true) ? "window window-normal" : ""}>
				{this.props.location != null && <Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>}
				<Row>
					<Col xs={24} xl={(this.props.offset == null || this.props.offset == true) ? { offset: 4, span: 16 } : 24}>
						{(this.props.showHeader == null || this.props.showHeader == true) && <Row>
							<Col xs={24}>
								<HeaderView
									title={title}
									mode={mode}
									onModeChanged={onModeChange}
									save={save}
									cancel={cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>}
						<Row>
							<Col xs={24}>
								<div className="card p-3 card-borderless">
									<Tabs defaultActiveKey="General information">
										<TabPane tab={<span>General information</span>} key="General information">
											<Row gutter={16}>
												<Col xs={24} md={8}>
													<AgentGeneralPartController
														model={model}
														isNew={isNew}
														mode={mode}
														currency={currency}
														onChangeCurrency={onChangeCurrency}
														setBusy={setBusy}
													/>
												</Col>
												<Col xs={24} md={16}>
													<AgentContactPartController
														parentModel={model}
														model={model.dynamicProperties["contacts"]}
														mode={mode}
														contextService={contextService}
														setBusy={setBusy}
													/>
												</Col>
											</Row>
											{this.props.location && this.props.history && this.props.match &&<Row>
												<Col xs={24}>
													<ChildrenAgents
														model={model}
														match={match}
														location={location}
														history={history}
														setBusy={setBusy}
													/>
												</Col>
											</Row>}
										</TabPane>
										<TabPane tab={<span>Brands, Policies & Markets</span>} key="Brands, Policies & Markets">
											<Row gutter={16}>
												<Col xs={24} md={8}>
													<AgentBrandController
														model={model}
														dataService={brandDataService}
														mode={mode}
														setBusy={setBusy}
													/>
												</Col>
												<Col xs={24} md={8}>
													<AgentPolicyController
														model={model}
														dataService={policyDataService}
														mode={mode}
														setBusy={setBusy}
													/>
												</Col>
												<Col xs={24} md={8}>
													<AgentMarketController
														model={model}
														dataService={marketDataService}
														mode={mode}
														setBusy={setBusy}
													/>
												</Col>
											</Row>
										</TabPane>
										{
											!isNew &&
											<TabPane tab={<span>Documents</span>} key="documents">
												<Row>
													<Col span={24}>
														<DocumentGenerationController
															containerId={model.documentsLibraryId}
															setBusy={setBusy}
															usage="Agents"
															targetId={model.id}
														/>
													</Col>
												</Row>
											</TabPane>
										}
									</Tabs>
								</div>
							</Col>
						</Row>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/agents/form/agent-form.view.tsx